// extracted by mini-css-extract-plugin
export default {"header":"App_header__rszhB","link":"App_link__8vib6","button":"App_button__CLBuL","subLink":"App_subLink__OrIfq","dropdownFooter":"App_dropdownFooter__jLUvf"};